<div class="field field-text" [ngClass]="typeClass">
  @if (label) {
    <span class="label">{{label}} @if (optionalString) {
      <span>({{optionalString}})</span>
    }</span>
  }
  <div class="d-flex align-items-center w-100 position-relative app-tooltip-wrap" [class.disabled-wrap]="disabled">

    <input
      style="min-width: 32px;"
      [ngStyle]="{'max-width': inputWidth ? inputWidth : ''}"
      #myinput
      [class.error-field]="error || errorTooltip"
      [type]="getType()"
      class="flex-grow-1"
      [(ngModel)]="localModel"
      (ngModelChange)="changes()"
      (blur)="onBlur($event)"
      (focus)="emitFocus.emit()"
      (keyup.enter)="onBlur(null); enter.emit()"
      [placeholder]="placeholder"
      [readonly]="disabled"
      [autocomplete]="autocomplete"
      placeHolderCharacter="_"
      />
    @if (type == 'password') {
      <button (click)="togglePwd = !togglePwd" tabindex="-1" class="toggle-show button-link underline">
        @if (!togglePwd) {
          <span>{{'fieldtext_show_pwd' | translate}}</span>
          }@if (togglePwd) {
          <span>{{'fieldtext_hide_pwd' | translate}}</span>
        }
      </button>
    }
    @if (afterString) {
      <span class="after-string passive-gray">{{afterString | display}}</span>
    }
    @if (errorTooltip) {
      <div class="app-tooltip app-tooltip-left-nowrap">{{errorTooltip}}</div>
    }
  </div>
  @if (error) {
    <span class="error-field-display">{{error}}</span>
  }
</div>